import { auth } from "@/config/host.config";
import { Component, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class GuestSorts extends Vue {
  children = "";
  pensioners = false;
  birthday = "";
  registrated = "all";
  cruise_code = "";
  gender = "";
  doc_type = "";
  citizenship = "";
  room_type = "";
  room_level = "";

  mounted(): void {
    const wiev = localStorage.getItem("hotel-guest-list-wiev");
    this.registrated = wiev && wiev !== "populated" ? wiev : "all";
  }

  onReset(): void {
    this.children = "";
    this.pensioners = false;
    this.birthday = "";
    this.cruise_code = "";
    this.gender = "";
    this.doc_type = "";
    this.citizenship = "";
    this.room_level = "";
    this.room_type = "";
  }

  @Watch("registrated")
  setRegistratedWiev(): void {
    localStorage.setItem("hotel-guest-list-wiev", this.registrated);
  }

  get isSortActive(): boolean {
    return !!(
      this.children ||
      this.pensioners ||
      this.birthday ||
      this.cruise_code ||
      this.gender ||
      this.doc_type ||
      this.citizenship ||
      this.room_type ||
      this.room_level
    );
  }
}
